import { TemplateBuilderModels } from "src/requests/templateBuilder/types/requestableModelSubsets";
import { action, fsa } from "ts-action";
import { NumberIndexedDictionary, TemplateId } from "../../globalTypes";
import { EditRowWithColumns } from "../../requests/tableRowActions/types";
import {
  AllDataTemplates,
  AllPresentationTemplates,
  AllTemplateBuilderModels,
  DataTemplateItem,
  PresentationTemplateItem,
} from "../../requests/templateBuilder/types";
import {
  ADD_NEW_D_AND_P_TEMPLATE_ITEM,
  DELETE_D_AND_P_TEMPLATE_ITEM,
  IS_FETCHING_EDIT_ROW,
  IS_FETCHING_SQL_QUERY,
  IS_FETCHING_TEMPLATE_BUILDER_MODEL,
  RECEIVE_EDIT_ROW,
  RECEIVE_SQL_QUERY,
  RECEIVE_TB_MODELS,
  RECEIVE_TEMPLATE_BUILDER,
  REVALIDATE_TEMPLATE_BUILDER,
  UPDATE_DATA_TEMPLATE,
  UPDATE_DATA_TEMPLATE_ITEM,
  UPDATE_DATA_TEMPLATE_ITEMS,
  UPDATE_DETAIL_TEMPLATES,
  UPDATE_DETAIL_TEMPLATES_ORDER,
  UPDATE_D_AND_P_TEMPLATE_ITEMS,
  UPDATE_EDIT_ROW,
  UPDATE_PRESENTATION_TEMPLATE,
  UPDATE_PRESENTATION_TEMPLATE_ITEM,
  UPDATE_PRESENTATION_TEMPLATE_ITEMS,
  UPDATE_TEMPLATE_BUILDER,
  SET_STATE_CHANGED,
} from "./actionTypes";
import { InvalidatableDatasetName } from "./types";

// ------------------MODEL-DATA---------------------------------
export const receiveTemplateBuilder = action(
  RECEIVE_TEMPLATE_BUILDER,
  fsa<{
    templateBuilder: AllTemplateBuilderModels;
    templateBuilderId: number;
  }>()
);

export const updateTemplateBuilder = action(
  UPDATE_TEMPLATE_BUILDER,
  fsa<{
    updatedTemplateBuilder: AllTemplateBuilderModels;
    templateBuilderId: number;
  }>()
);

export const setStateChanged = action(
  SET_STATE_CHANGED,
  fsa<{
    newState: boolean;
    templateBuilderId: number;
  }>()
);

export const revalidateTemplateBuilder = action(
  REVALIDATE_TEMPLATE_BUILDER,
  fsa<{
    updatedTemplateBuilder: AllTemplateBuilderModels;
    templateBuilderId: number;
  }>()
);

export const isFetchingModel = action(
  IS_FETCHING_TEMPLATE_BUILDER_MODEL,
  fsa<{
    templateBuilderId: number;
    isFetching: boolean;
  }>()
);

export const updateDataTemplate = action(
  UPDATE_DATA_TEMPLATE,
  fsa<{
    templateBuilderId: number;
    dataTemplate: AllDataTemplates;
  }>()
);

export const updateDataTemplateItems = action(
  UPDATE_DATA_TEMPLATE_ITEMS,
  fsa<{
    templateBuilderId: number;
    items: NumberIndexedDictionary<DataTemplateItem>;
  }>()
);

export const updateDataTemplateItem = action(
  UPDATE_DATA_TEMPLATE_ITEM,
  fsa<{
    templateBuilderId: number;
    item: Partial<DataTemplateItem> & { globalId: number };
  }>()
);

export const updatePresentationTemplate = action(
  UPDATE_PRESENTATION_TEMPLATE,
  fsa<{
    templateBuilderId: number;
    presentationTemplate: AllPresentationTemplates;
  }>()
);

export const updatePresentationTemplateItems = action(
  UPDATE_PRESENTATION_TEMPLATE_ITEMS,
  fsa<{
    templateBuilderId: number;
    items: NumberIndexedDictionary<PresentationTemplateItem>;
  }>()
);

export const updatePresentationTemplateItem = action(
  UPDATE_PRESENTATION_TEMPLATE_ITEM,
  fsa<{
    templateBuilderId: number;
    item: PresentationTemplateItem;
  }>()
);

export const updateBothTemplateItems = action(
  UPDATE_D_AND_P_TEMPLATE_ITEMS,
  fsa<{
    templateBuilderId: number;
    item: DataTemplateItem;
  }>()
);

export const addNewDAndPTemplateItem = action(
  ADD_NEW_D_AND_P_TEMPLATE_ITEM,
  fsa<{
    templateBuilderId: number;
  }>()
);

export const deleteDAndPTemplateItem = action(
  DELETE_D_AND_P_TEMPLATE_ITEM,
  fsa<{
    templateBuilderId: number;
    itemId: number;
  }>()
);

export const updateDetailTemplates = action(
  UPDATE_DETAIL_TEMPLATES,
  fsa<{
    templateBuilderId: number;
    detailTemplates: number[];
  }>()
);

export const updateDetailTemplatesOrder = action(
  UPDATE_DETAIL_TEMPLATES_ORDER,
  fsa<{
    templateBuilderId: number;
    templatesOrder: NumberIndexedDictionary<number>;
  }>()
);

export const receiveTemplateBuilderModels = action(
  RECEIVE_TB_MODELS,
  fsa<{ templateBuilderId: number; models: TemplateBuilderModels }>()
);

// --------------------------STATE INVALIDATION-----------------------
export const invalidateDatasetForAllTemplates = action(
  "TEMPLATE BUILDER > INVALIDATE DATA SET",
  fsa<{ dataset: InvalidatableDatasetName }>()
);

export const revalidateDatasetForTemplate = action(
  "TEMPLATE BUILDER > REVALIDATE DATA SET",
  fsa<{ templateId: TemplateId; dataset: InvalidatableDatasetName }>()
);

export const invalidateWholeStateForTemplate = action(
  "TEMPLATE BUILDER > INVALIDATE STATE FOR TEMPLATE",
  fsa<{ templateId: TemplateId }>()
);

// --------------------------EDIT-ROW-DATA-----------------------
export const receiveEditRow = action(
  RECEIVE_EDIT_ROW,
  fsa<{
    editRow: EditRowWithColumns;
    templateBuilderId: number;
  }>()
);

export const isFetchingEditRow = action(
  IS_FETCHING_EDIT_ROW,
  fsa<{
    isFetching: boolean;
    templateBuilderId: number;
  }>()
);

export const updateTemplateBuilderEditRow = action(
  UPDATE_EDIT_ROW,
  fsa<{
    newEditRow: EditRowWithColumns;
    templateBuilderId: number;
  }>()
);

// -----------------------SQL-QUERY-DATA--------------------------
export const receiveSqlQuery = action(
  RECEIVE_SQL_QUERY,
  fsa<{
    sqlQuery: string | null;
    templateBuilderId: number;
  }>()
);

export const isFetchingSqlQuery = action(
  IS_FETCHING_SQL_QUERY,
  fsa<{
    isFetching: boolean;
    templateBuilderId: number;
  }>()
);
